import { RootState } from "@/store/store";
import { resourceExplorerChartSettingsSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/chart/settings/resourceExplorerChartSettingsSelector";
import { resourceExplorerViewDataByIdSelector } from "@/store/resource-explorer/selectors/resource-explorer-by-id/resourceExplorerViewDataByIdSelector";
import { billingExplorerDefaultChartSettings } from "@/components/pages/resource-explorer/components/resource-explorer-card/utils/constants/common";
import { billingExplorerChartSettingsSelectedBudgetChangedSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/checkers/billingExplorerChartSettingsSelectedBudgetChangedSelector";

export const billingExplorerChartSettingsChangedSelector = (
  state: RootState,
  id: string,
) => {
  const chartSettings = resourceExplorerChartSettingsSelector(state);
  const initialReport = resourceExplorerViewDataByIdSelector(state, id);
  const reportBudgetChanged =
    billingExplorerChartSettingsSelectedBudgetChangedSelector(state, id);

  const initialChartSettings = initialReport?.is_default
    ? billingExplorerDefaultChartSettings
    : initialReport?.chart_settings;

  return (
    chartSettings?.series !== initialChartSettings?.series ||
    chartSettings?.scale !== initialChartSettings?.scale ||
    !!chartSettings?.show_data_labels !==
      !!initialChartSettings?.show_data_labels ||
    !!chartSettings?.show_legends !== !!initialChartSettings?.show_legends ||
    !!chartSettings?.show_trendline !==
      !!initialChartSettings?.show_trendline ||
    !!chartSettings?.show_budget_line !==
      !!initialChartSettings?.show_budget_line ||
    !!chartSettings?.display_forecast !==
      !!initialChartSettings?.display_forecast ||
    !!chartSettings?.cumulative_line !==
      !!initialChartSettings?.cumulative_line ||
    reportBudgetChanged
  );
};
